var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 920 813",
    width: 920,
    height: 813,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 487,
    y1: 601.3,
    x2: 600.7,
    y2: 601.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a7d5a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7cc364"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#e3e2e8}.b{fill:#89cca4}.c{fill:#59bd85}.d{fill:#89cca2}.e{fill:#fcbc55}.f{fill:#9e8c76}.g{fill:#bba387}.h{fill:#d5c2af}.i{fill:#50803a}.j{fill:#6db844}.k{fill:#fec557}.l{mix-blend-mode:multiply;fill:#9184ab}.m{mix-blend-mode:multiply;fill:#aaa0bb}.n{fill:#aba1cd}.o{fill:#ef8eba}.p{fill:#ee5ea1}.q{fill:#c44f88}.r{fill:#e7e0ed}.s{fill:#8d4f9f}.t{fill:#f079af}.u{fill:#5e55a4}.v{fill:#8f86c0}.w{fill:#d19626}.x{fill:#8cccf0}.y{fill:#feca5a}.z{fill:#fcb629}.A{mix-blend-mode:multiply;fill:#b0a7c2}.B{fill:#f395be}.C{fill:#5b578d}.D{fill:#ef9e97}.E{fill:#ed2961}.F{fill:#f9f8fa}.G{fill:#dc8d87}.H{fill:#585f8f}.I{fill:#faae3e}.J{fill:#f89a35}.K{fill:#fbb331}.L{fill:#d28a5f}.M{fill:#e9b98f}.N{fill:#ad6c43}.O{fill:#d3dce0}.P{fill:#e4a67a}.Q{fill:#b9cad6}.R{fill:#d1e288}.S{fill:#4ca05a}.T{fill:#cb996e}.U{fill:#f4dab5}.V{fill:#5dbc73}.W{fill:#7cc36f}.X{fill:#e9626e}.Y{fill:#e98888}.Z{fill:#95aeba}.a0{fill:#aba1bd}.a1{fill:#b4c6ce}.a2{fill:#dae5ea}.a3{mix-blend-mode:multiply;fill:#b0a1be}.a4{fill:#d4dbdf}.a5{fill:#bcc8d4}.a6{fill:#eef0f1}.a7{fill:#99acb8}.a8{fill:#0c2337}.a9{fill:#546573}.aa{fill:#758798}.ab{fill:#56823b}.ac{fill:#39612d}.ad{fill:#416830}.ae{fill:#26451e}.af{fill:#0b0c08}.ag{fill:#1e3a47}.ah{fill:#6a7a8a}.ai{fill:#43535e}.aj{fill:#9eb6c8}.ak{fill:#000102}.al{fill:#9b7063}.am{fill:#7cc364}.an{fill:#72c055}.ao{fill:#c3dbe8}.ap{fill:#ead7d1}.aq{fill:#414635}.ar{fill:#aad7b6}.as{fill:#c3e1cc}.at{fill:url(#g1)}.au{fill:#6caa57}.av{fill:#3a4d5b}.aw{fill:#57626e}.ax{fill:#143642}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m202.1 369.8c4.6 2.6 4.6 6.9 0 9.6-4.6 2.7-12.1 2.7-16.7 0-4.6-2.7-4.6-7 0-9.6 4.6-2.7 12.1-2.7 16.7 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m263.7 339.3l-58.2 33.6c-1.9 1.1-5.1 1.1-7.1 0-2-1.1-2-3 0-4.1l58.1-33.6c2-1.1 5.2-1.1 7.2 0 2 1.1 2 3 0 4.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m350 289.5l-58.1 33.6c-2 1.1-5.2 1.1-7.2 0-2-1.2-2-3 0-4.2l58.2-33.5c1.9-1.2 5.1-1.2 7.1 0 2 1.1 2 2.9 0 4.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m163.5 530.1l-141 81.5c-4.6 2.6-12 2.6-16.6 0-4.6-2.7-4.6-7 0-9.6l141.1-81.5c4.5-2.6 12-2.6 16.5 0 4.6 2.7 4.6 7 0 9.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m272.5 467.2l-74.5 43c-4.6 2.7-12 2.7-16.6 0-4.6-2.6-4.6-6.9 0-9.6l74.5-43c4.6-2.7 12-2.7 16.6 0 4.6 2.6 4.6 6.9 0 9.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m205.4 463.2l-141.1 81.5c-4.6 2.6-12 2.6-16.6 0-4.6-2.7-4.6-7 0-9.6l141.1-81.5c4.5-2.6 12-2.6 16.6 0 4.5 2.7 4.5 6.9 0 9.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m385.7 359l-141 81.5c-4.6 2.6-12 2.6-16.6 0-4.6-2.7-4.6-7 0-9.6l141-81.5c4.6-2.6 12-2.6 16.6 0 4.6 2.7 4.6 7 0 9.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m466.7 397.7l-141 81.5c-4.6 2.6-12 2.6-16.6 0-4.6-2.7-4.6-6.9 0-9.6l141-81.5c4.6-2.6 12-2.6 16.6 0 4.6 2.7 4.6 7 0 9.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m200.5 551.5l-41.2 23.8c-4.6 2.7-12 2.7-16.6 0-4.6-2.6-4.6-6.9 0-9.6l41.3-23.8c4.5-2.7 12-2.7 16.5 0 4.6 2.6 4.6 6.9 0 9.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m554.5 347l-41.3 23.8c-4.6 2.7-12 2.7-16.6 0-4.5-2.6-4.5-6.9 0-9.5l41.3-23.9c4.6-2.6 12-2.6 16.6 0 4.6 2.7 4.6 6.9 0 9.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m233.4 404.2l-141 81.5c-4.6 2.7-12 2.7-16.6 0-4.6-2.6-4.6-6.9 0-9.6l141-81.5c4.6-2.6 12-2.6 16.6 0 4.6 2.7 4.6 7 0 9.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m321.2 353.5l-41.3 23.9c-4.6 2.6-12 2.6-16.6 0-4.5-2.7-4.5-7 0-9.6l41.3-23.9c4.6-2.6 12-2.6 16.6 0 4.6 2.7 4.6 7 0 9.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m4.9 643.1l6.2 1.2c0.5 0.1 1.1 0.1 1.5-0.1l5.3-2.3c1.1-0.4 2.6 0 2.6 0.8l-0.1 3.8c0 0.3 0.3 0.6 0.7 0.8l5.4 2.2c1.1 0.4 0.8 1.4-0.5 1.7l-6.3 1.1c-0.5 0.1-0.9 0.3-1.1 0.6l-1.9 3.6c-0.4 0.8-2.1 0.9-2.9 0.3l-3.8-3.1c-0.3-0.3-0.8-0.4-1.4-0.4h-6.5c-1.4 0.1-2.2-0.8-1.4-1.5l4-3c0.3-0.3 0.4-0.6 0.2-0.9l-2.1-3.6c-0.5-0.7 0.8-1.4 2.1-1.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m31.6 627.7l6.2 1.2c0.5 0.1 1.1 0.1 1.5-0.1l5.3-2.3c1.1-0.5 2.6 0 2.6 0.8l-0.1 3.8c0 0.3 0.3 0.6 0.7 0.8l5.4 2.2c1.1 0.4 0.8 1.4-0.5 1.6l-6.3 1.2c-0.5 0.1-0.9 0.3-1 0.6l-2 3.6c-0.4 0.8-2.1 0.9-2.9 0.3l-3.8-3.1c-0.3-0.3-0.8-0.4-1.4-0.4h-6.5c-1.4 0-2.2-0.9-1.4-1.5l4-3c0.3-0.3 0.4-0.6 0.2-0.9l-2.1-3.6c-0.4-0.7 0.8-1.4 2.1-1.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m58.3 612.3l6.2 1.2c0.5 0.1 1.1 0.1 1.5-0.1l5.3-2.3c1.1-0.5 2.6 0 2.6 0.8l-0.1 3.8c0 0.3 0.3 0.6 0.7 0.8l5.4 2.1c1.1 0.5 0.8 1.5-0.5 1.7l-6.3 1.1c-0.5 0.1-0.9 0.4-1 0.7l-2 3.6c-0.4 0.7-2.1 0.9-2.9 0.3l-3.8-3.1c-0.3-0.3-0.8-0.4-1.4-0.4h-6.5c-1.4 0-2.2-0.9-1.4-1.5l4-3c0.3-0.3 0.4-0.6 0.2-0.9l-2.1-3.6c-0.4-0.8 0.8-1.5 2.1-1.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m85 596.9l6.2 1.2c0.5 0.1 1.1 0 1.5-0.1l5.3-2.3c1.1-0.5 2.6 0 2.6 0.8l-0.1 3.7c0 0.4 0.3 0.7 0.7 0.8l5.4 2.2c1.1 0.5 0.8 1.5-0.5 1.7l-6.3 1.1c-0.5 0.1-0.9 0.4-1 0.6l-2 3.7c-0.4 0.7-2.1 0.9-2.9 0.2l-3.8-3.1c-0.3-0.2-0.8-0.4-1.3-0.4l-6.6 0.1c-1.4 0-2.2-0.9-1.4-1.5l4-3.1c0.3-0.2 0.4-0.5 0.2-0.8l-2.1-3.6c-0.4-0.8 0.8-1.5 2.1-1.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m111.7 581.5l6.2 1.2c0.5 0.1 1.1 0 1.5-0.2l5.3-2.2c1.1-0.5 2.6-0.1 2.6 0.7l-0.1 3.8c0 0.3 0.3 0.6 0.7 0.8l5.4 2.2c1.1 0.5 0.8 1.4-0.5 1.7l-6.3 1.1c-0.5 0.1-0.9 0.3-1 0.6l-2 3.7c-0.4 0.7-2.1 0.9-2.9 0.2l-3.8-3.1c-0.3-0.2-0.8-0.4-1.3-0.4l-6.6 0.1c-1.4 0-2.2-0.9-1.4-1.5l4-3.1c0.3-0.2 0.4-0.6 0.2-0.9l-2.1-3.5c-0.4-0.8 0.8-1.5 2.1-1.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m171 720.1l-141.1 81.5c-4.5 2.6-12 2.6-16.5 0-4.6-2.7-4.6-7 0-9.6l141-81.5c4.6-2.7 12-2.7 16.6 0 4.6 2.6 4.6 6.9 0 9.6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m279.9 657.1l-74.5 43.1c-4.6 2.6-12 2.6-16.6 0-4.6-2.7-4.6-6.9 0-9.6l74.6-43.1c4.5-2.6 12-2.6 16.5 0 4.6 2.7 4.6 7 0 9.6z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m212.8 653.2l-141 81.4c-4.6 2.7-12.1 2.7-16.6 0-4.6-2.6-4.6-6.9 0-9.5l141-81.5c4.6-2.7 12-2.7 16.6 0 4.6 2.6 4.6 6.9 0 9.6z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m393.2 549l-141.1 81.5c-4.6 2.6-12 2.6-16.6 0-4.6-2.7-4.6-7 0-9.6l141.1-81.5c4.5-2.7 12-2.7 16.6 0 4.5 2.6 4.5 6.9 0 9.6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m474.2 587.7l-141.1 81.5c-4.6 2.6-12 2.6-16.6 0-4.6-2.7-4.6-7 0-9.6l141.1-81.5c4.6-2.6 12-2.6 16.6 0 4.5 2.7 4.5 6.9 0 9.6z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m208 741.5l-41.3 23.8c-4.6 2.6-12 2.6-16.6 0-4.6-2.6-4.6-6.9 0-9.6l41.3-23.8c4.6-2.7 12-2.7 16.6 0 4.6 2.6 4.6 6.9 0 9.6z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m562 537l-41.3 23.8c-4.6 2.7-12 2.7-16.6 0-4.6-2.6-4.6-6.9 0-9.6l41.3-23.8c4.5-2.7 12-2.7 16.6 0 4.5 2.6 4.5 6.9 0 9.6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m240.9 594.2l-141.1 81.5c-4.6 2.6-12 2.6-16.6 0-4.6-2.7-4.6-7 0-9.6l141.1-81.5c4.5-2.6 12-2.6 16.6 0 4.5 2.7 4.5 7 0 9.6z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m328.7 543.5l-41.3 23.8c-4.6 2.7-12 2.7-16.6 0-4.6-2.6-4.6-6.9 0-9.5l41.3-23.9c4.5-2.6 12-2.6 16.6 0 4.5 2.7 4.5 6.9 0 9.6z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m387.4 679.7l-141.1 81.4c-4.5 2.7-12 2.7-16.6 0-4.5-2.6-4.5-6.9 0-9.6l141.1-81.4c4.6-2.7 12-2.7 16.6 0 4.6 2.6 4.6 6.9 0 9.6z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m496.3 616.7l-74.5 43.1c-4.6 2.6-12 2.6-16.6 0-4.6-2.7-4.6-7 0-9.6l74.5-43.1c4.6-2.6 12.1-2.6 16.6 0 4.6 2.7 4.6 7 0 9.6z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m429.2 612.7l-141.1 81.5c-4.5 2.7-12 2.7-16.5 0-4.6-2.6-4.6-6.9 0-9.6l141-81.4c4.6-2.7 12-2.7 16.6 0 4.6 2.6 4.6 6.9 0 9.5z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m609.5 508.6l-141 81.4c-4.6 2.7-12 2.7-16.6 0-4.6-2.6-4.6-6.9 0-9.5l141.1-81.5c4.5-2.7 12-2.7 16.5 0 4.6 2.6 4.6 6.9 0 9.6z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m690.6 547.3l-141.1 81.4c-4.6 2.7-12 2.7-16.6 0-4.6-2.6-4.6-6.9 0-9.5l141.1-81.5c4.5-2.7 12-2.7 16.6 0 4.5 2.6 4.5 6.9 0 9.6z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m424.4 701l-41.3 23.9c-4.6 2.6-12 2.6-16.6 0-4.6-2.7-4.6-7 0-9.6l41.3-23.9c4.6-2.6 12-2.6 16.6 0 4.6 2.7 4.6 7 0 9.6z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m778.3 496.6l-41.2 23.8c-4.6 2.6-12 2.6-16.6 0-4.6-2.6-4.6-6.9 0-9.6l41.3-23.8c4.5-2.7 12-2.7 16.5 0 4.6 2.6 4.6 6.9 0 9.6z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m457.2 553.8l-141 81.5c-4.6 2.6-12 2.6-16.6 0-4.6-2.7-4.6-7 0-9.6l141.1-81.5c4.5-2.6 12-2.6 16.5 0 4.6 2.6 4.6 6.9 0 9.6z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m545 503.1l-41.2 23.8c-4.6 2.7-12 2.7-16.6 0-4.6-2.6-4.6-6.9 0-9.6l41.3-23.8c4.5-2.7 12-2.7 16.5 0 4.6 2.6 4.6 6.9 0 9.6z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m698.4 371.7l-141 81.5c-4.6 2.6-12 2.6-16.6 0-4.6-2.7-4.6-7 0-9.6l141-81.5c4.6-2.7 12-2.7 16.6 0 4.6 2.6 4.6 6.9 0 9.6z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m764.5 407.6l-141.1 81.5c-4.6 2.6-12 2.6-16.6 0-4.6-2.7-4.6-7 0-9.6l141.1-81.5c4.6-2.6 12-2.6 16.6 0 4.5 2.7 4.5 6.9 0 9.6z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m531.2 414.1l-141.1 81.5c-4.6 2.6-12 2.6-16.6 0-4.6-2.7-4.6-7 0-9.6l141.1-81.5c4.6-2.6 12-2.6 16.6 0 4.5 2.7 4.5 7 0 9.6z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m619 363.4l-41.3 23.8c-4.6 2.7-12 2.7-16.6 0-4.6-2.6-4.6-6.9 0-9.5l41.3-23.9c4.6-2.6 12-2.6 16.6 0 4.5 2.7 4.5 6.9 0 9.6z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m834.3 367.5l-41.3 23.9c-4.5 2.6-12 2.6-16.5 0-4.6-2.7-4.6-7 0-9.6l41.2-23.9c4.6-2.6 12.1-2.6 16.6 0 4.6 2.7 4.6 7 0 9.6z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b",
    d: "m329.9 616.3c-3.2 29.6-17.9 51.8-27.1 65.6q-24.8-5.5-186.5-41.2 16.9-25.5 33.8-51.1 165 36.5 179.8 26.7zm-29.1 50.2l16.9-25.5c-2.1-0.4-4.1-1.1-5.9-2.4-1.4-1.1-2.7-2.5-3-4.2-0.2-1.3 0.2-2.7 0.9-3.7l-142.2-31.4c-0.9 1.3-2.3 2.3-3.7 3.1-2 1-4.1 1.5-6.2 1.8-2.7 0.4-5.5 0.3-8.1-0.3l-16.9 25.4c2.1 0.5 4.2 1.2 5.9 2.5 1.5 1.1 2.7 2.5 3 4.2 0.2 1.3-0.1 2.7-0.8 3.7l142.2 31.4c0.8-1.3 2.2-2.3 3.7-3.1 1.9-1 4-1.5 6.1-1.8 2.7-0.4 5.5-0.3 8.1 0.3z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m317.7 641l-16.9 25.5c-2.6-0.6-5.4-0.7-8.1-0.3-2.1 0.3-4.2 0.8-6.1 1.8-1.5 0.8-2.9 1.8-3.7 3.1l-142.2-31.4c0.7-1 1-2.4 0.8-3.7-0.3-1.7-1.5-3.1-3-4.2-1.7-1.3-3.8-2-5.9-2.5l16.9-25.4c2.6 0.6 5.4 0.7 8.1 0.3 2.1-0.3 4.2-0.8 6.2-1.8 1.4-0.8 2.8-1.8 3.7-3.1l142.2 31.4c-0.7 1-1.1 2.4-0.9 3.7 0.3 1.7 1.6 3.1 3 4.2 1.8 1.3 3.8 2 5.9 2.4zm-66.3-4.3c0.3-1.9 0-3.9-0.8-5.6-1-2.2-2.8-4-4.7-5.5-3.1-2.3-6.7-3.8-10.4-4.7-3.7-1-7.6-1.5-11.4-1.5-3.9 0-7.7 0.5-11.4 1.4-2.8 0.8-5.5 1.8-8 3.2-2.1 1.2-4 2.7-5.5 4.6-1.2 1.5-2.1 3.3-2.4 5.2-0.3 1.9 0 3.9 0.8 5.6 1 2.2 2.8 4 4.7 5.4 3.1 2.4 6.7 3.8 10.4 4.8 3.7 1 7.5 1.5 11.4 1.5 3.8 0 7.7-0.5 11.4-1.5 2.7-0.7 5.4-1.7 8-3.2q0 0 0 0c2-1.2 4-2.6 5.5-4.5 1.2-1.5 2.1-3.3 2.4-5.2z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m250.6 631.1c0.8 1.7 1.1 3.7 0.8 5.6-0.3 1.9-1.2 3.7-2.4 5.2-1.5 1.9-3.5 3.3-5.5 4.5q0 0 0 0c-2.6 1.5-5.3 2.5-8 3.2-3.7 1-7.6 1.5-11.4 1.5-3.9 0-7.7-0.5-11.4-1.5-3.7-1-7.3-2.4-10.4-4.8-1.9-1.4-3.7-3.2-4.7-5.4-0.8-1.7-1.1-3.7-0.8-5.6 0.3-1.9 1.2-3.7 2.4-5.2 1.5-1.9 3.4-3.4 5.5-4.6 2.5-1.4 5.2-2.4 8-3.2 3.7-0.9 7.5-1.4 11.4-1.4 3.8 0 7.7 0.5 11.4 1.5 3.7 0.9 7.3 2.4 10.4 4.7 1.9 1.5 3.7 3.3 4.7 5.5z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m772.1 68.6c4.9 1.3 7.9 6.5 4.1 15.2v-1.9c0-4.5-1.6-9.4-4.1-13.3z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m765.7 139.9v62.9l-1.5 0.9v-64.6z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m764.2 139.1v64.6l-3-4.6v-1.6-60.2z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m761.2 137.3v60.2l-3.4-5.2v-57z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m758.9 91.1c-2.3 1.5-6.1 0-9.1-4.5 2-1.4 3.9-2.7 5.9-3.9 1.2 2.1 3.1 4.1 5.2 5-0.3 1.6-1 2.8-2 3.4z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m757 192.7v-57.8l0.8 0.4v57z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m753.1 72.5q0.1 0 0.1 0.1-0.1 0.6-0.1 1.3-3.1 1.7-6.1 3.8c0.1-4.1 2.4-6.6 6.1-5.2z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m751.3 159.4l0.9 0.5v1.7l-2.4-1.4z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m751.3 172.6l0.9 0.6v1.7l-2.4-1.4z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m749.8 160.2l2.4 1.4v-1.7-8.8l-2.4-1.3v-19l7.2 4.1v57.8l-7.2-11v-8.2l2.4 1.4v-1.7-8.8l-2.4-1.4z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m753.1 72.5c-3.7-1.4-6 1.1-6.1 5.2-3.1 2.1-6.2 4.4-9.1 6.8v-17.8c0-4 1.4-6.9 3.5-8.1 2-1.1 4.5-1 7.3 0.6l10.6 6.1c5.9 3.4 10.9 12.3 10.9 20.1v57.1l-4.5-2.6-1.5-0.8-3-1.8-3.4-2-0.8-0.4-7.2-4.1-11.9-6.9v-0.1-10.9-16.5-0.1c3.7-3.4 7.8-6.7 11.9-9.7 3 4.5 6.8 6 9.1 4.5 1-0.6 1.7-1.8 2-3.4q0.2-0.8 0.2-1.8c0-1.9-0.5-3.8-1.2-5.6-1.3-3.1-3.5-5.8-5.6-7.1q-0.5-0.4-1.1-0.6 0-0.1-0.1-0.1z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m747.2 55.3q0.1-0.1 0.3-0.2 0.8-0.5 1.8-0.6c2-0.3 3.7 0.2 5.5 1.2l10.6 6.1c2.5 1.5 4.8 3.9 6.7 6.8 2.5 3.9 4.1 8.8 4.1 13.3v1.9 55.2l-6 3.5v-57.1c0-7.8-5-16.7-10.9-20.1l-10.6-6.1c-2.8-1.6-5.3-1.7-7.3-0.6q2.9-1.7 5.8-3.3z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m717.7 123.1c0.8 0 1.9-0.3 2.7-0.5 5.7-1.7 12.7-6.2 17.5-9.7v10.9c-6 3.8-16.4 9.8-23.2 7.9-4.5-1.2-7.2-5.4-5.5-11.8 2.2-8.5 11.5-19.2 17.8-25.5 3.2-3.3 7-6.7 10.9-9.9 2.9-2.4 6-4.7 9.1-6.8q3-2.1 6.1-3.8 0.6-0.4 1.2-0.7c2.1 1.3 4.3 4 5.6 7.1q-2.1 1.1-4.2 2.4c-2 1.2-3.9 2.5-5.9 3.9-4.1 3-8.2 6.3-11.9 9.7v0.1c-2.6 2.3-5.1 4.8-7.3 7.1-4 4.4-11.3 13-12.8 18.8q-0.1 0.5-0.1 0.8z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "l",
    d: "m759.9 80.3c0 0-2.7 1.1-4.2 2.4 2.5 4.1 5.2 5 5.2 5 0 0 0 0.7-0.7 1.8-0.6 1.1-1.3 1.6-1.3 1.6 0 0-0.3 3.8-0.1 4.5q3.3 14 6.3 28c0.9 4.2 2.3 12.7 2.3 12.7l-1.7 3.6 0.1 44c0 0 6.8-2.8 10.2-4.3 10.3-4.6 21.2-7.2 32.4-8.4 10-1 19.8-1 29.6 1.2 3.1 0.8 6.3 1.9 9.2 3.4 8.3 4.3 9.4 8.8 4.5 17 4.6 4.6 11.8 5.7 16 11.5-3.7 3.1-7.2 5.3-12.1 5.2-11.2-0.2-22.5 0.5-33.7-0.2-10.4-0.8-20.6 1.9-31 1.2-7.8-0.5-15.4-1.3-22.6-4.6-1.1-0.5-4.1-2.2-4.1-2.2l-3-4.6v-1.6l-3.4-5.2-0.8 0.4-7.1-11v-8.2l7.2 4.8c0 0-0.1-3.1-0.1-4.2 0-10.4-0.1-20.9 0.1-31.3 0-3-0.9-4.9-3.6-6.3-1.8-0.8-3.6-5.7-3.6-5.7l11.3 6.5c0 0-2.9-16.9-4.5-24.7-1.5-7.8-3.3-15.5-5.1-23.4 1.2-0.8 2.2-1.5 3.4-2.3-0.4-0.5-0.6-0.9-0.9-1.1-1.5-1-3-0.1-4.2 0.8-11.6 8.7-22.1 18-29.8 30.5-0.5 0.7-2 3.9-2.4 6-0.3 1.6 0.6 2 3.6 2.4 3 0.4 5.9 0 8.7-1.2 2.4-1.1 7.9-3.4 7.9-3.4v2.9c0 0-10.6 7.4-18.3 8-1.5 0.2-3 0.2-4.4-0.1-5-1.2-6.6-4.5-3.9-8.8 2.9-4.5 6.2-8.9 9.7-13 9.5-11.1 20.5-20.7 32.4-29 1-0.8 2-1.6 3.1-2.6-2.4-3.7-9.5-0.6-9.5-0.6 0 0-0.5-4.5 3.7-5.6 6 0 9.2 8.2 9.2 8.2zm83.1 108.8c2-5 1.3-7.7-2.9-9.7-2.9-1.3-6.2-2.1-9.4-2.8-6.8-1.3-13.7-1-20.6-0.2-7.5 0.8-14.7 2.3-21.7 4.7-5 1.7-9.8 4-14 7.3-2.1 1.7-3.9 3.5-4.1 6.9 3.2-0.8 6.1-0.4 9.1-0.1 3.1 0.2 6.3-1 9.7-1.5-0.9-1.1-1.8-2.1-2.6-3 2.7-2.6 5.6-3.4 8.9-3.3 15.8 0.7 31.6-1.4 47.6 1.7zm-84.4-47.7c0 13.1-0.1 25.8 0 38.5 0 2.9 0.8 3.2 4.8 2.9 0.2-0.6 0.5-1.2 0.5-1.8 0-11.9 0.1-23.8 0-35.7 0-3.4-0.4-3.6-5.3-3.9zm23.6 62.2c8 2.1 16 2.1 24.1 0q-12.1 0-24.1 0z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m776.2 139l-6 3.5c0 0-0.1-54.5-0.1-56.3 0.1-2.6-0.1-5.2-1-7.6 1.2-0.8 3.9-2.7 5.7-4 0-1.1-0.9-2.9-1.9-4.6 0.7 0.1 2.5 1.6 2.7 1.9 2.7 2.4 2.6 3.6 2.2 6.7-0.4 2.8-1.6 5.2-1.6 5.2z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m796.1 361.5v19.7l-140.4 81.1v-9.9-9.8z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m796.1 202v12.1l-19.5 11.2-18.2 10.5-9 5.3-93.7 54.1v-0.9-11.2z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m796.1 202l-140.4 81.1c-40.4-55.8-186.8-258.2-187.5-259.1 1.2 0.6 295.3 160.3 327.9 178z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m796.1 202l-327.9-178.1-17-21z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m796.1 361.5l-140.4 81.1-104.5-60.3-66.7 38.5-240.5-138.8 37.7-21.8v21.8l202.8 117 66.7-38.5 44.5 25.7 60 34.6 54.8-31.6 38.8-22.4h0.1l9 5.2 18.2-10.5v-11.2z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m776.6 350.3v11.2l-18.2 10.5v-136.2l18.2-10.5z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m758.4 235.8v136.2l-9-5.2v-0.1-125.6z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m720.5 280.7l-64.3 37.1-70-40.4 9.5-5.5 60 34.7 54.8-31.7z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m710.5 274.9l-54.8 31.7v-11.4l93.7-54.1v125.6 0.1h-0.1l-38.8 22.4v-6-13.7-76.7l10-5.8v-6.3z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m650.6 348.6l59.9 34.6-54.8 31.7-60-34.6z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m656.2 317.8l64.3-37.1v6.3l-10 5.8-54.3 31.4z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m710.5 389.2l-54.8 31.6v-5.9l54.8-31.7z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m656.2 317.8v6.4l-5.6-3.3-54.9-31.6-9.5-5.5v-6.4z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m656.2 324.2l54.3-31.4v76.7 13.7l-59.9-34.6v-27.7z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m655.7 294.3v0.9l-104.5-60.3v-0.5-11.6l104.5 60.3z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m655.7 283.1l-104.5-60.3c-3.1-7.4 8.4 20.1-83-198.8 118.8 164.1 123.2 170.1 187.5 259.1z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m655.7 452.4l-18.1 10.4-104.4-60.3 18-10.4z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m595.7 289.3l54.9 31.6v27.7l-54.9 31.7v-13.8z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m637.6 462.8l18.1-10.4v9.9l-18.1 10.4z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m655.7 414.9v5.9l-60-34.6v-5.9z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "m595.7 271.9l-9.5 5.5v6.4l9.5 5.5v77.2 13.8 5.9l-44.5-25.7v-125.6l104.5 60.3v11.4z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m551.2 382.3l104.5 60.3v9.8l-104.5-60.3z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m551.2 234.9v125.6l-66.7 38.5v-125.6z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m551.2 234.4v0.5l-66.7 38.5v-0.9-11.2l66.7-38.5z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m551.2 222.8l-66.7 38.5-1.5-21.7-0.3-5.4-1.6-23.3-0.4-5.4v-0.1l-1.6-23.2-0.4-5.4-1.6-23.8-0.4-5.5-1.6-23.5-0.4-5.4-1.5-22.7-0.4-5.5-1.6-23.7-0.4-5.4-2.6-37.3 13.1 31.2 1.9 4.5 8.3 20 1.9 4.5 7.9 19 1.9 4.6 8.2 19.7 1.9 4.5 8.4 20 1.9 4.6 8.1 19.4 1.9 4.6 8.2 19.5 1.8 4.5z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m533.2 402.5l104.4 60.3v9.9l-104.4-60.3z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m484.5 420.8l66.7-38.5v9.8l-18 10.4v9.9l-48.7 28.1z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m484.5 420.8v19.7l-240.5-138.9v-19.6z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m484.5 272.5v0.9l-202.8-117.1-37.7-21.7v-12.1l240.5 138.8z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m484.5 261.3l-240.5-138.8c0.3-0.1 223.9-98.4 224.2-98.5 0 0.3 16.3 237 16.3 237.3z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m462.2 272v86l-4 2.3v-86z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m451.1 278.6v64.5l-24-13.8v-64.5z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m423.1 262.5l4 2.3v64.5l-4 2.3z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m427.1 329.3l24 13.8v4.7l-28-16.2z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "z",
    d: "m458.2 360.3l-42.2-24.4v-86l42.2 24.4zm-7.1-12.6v-69.1l-24-13.8-4-2.4v69.2z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m418 37.2v-15.2l33.2-19.1 17 21-72.5 31.9-2.1-4.7z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m420 247.6l42.2 24.4-4 2.3-42.2-24.4z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m418 22v15.2l-24.4 13.9v-22.8l24.4-14.1z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m408.2 14.2l-14.6 8.4q0-8.4 0-16.9z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m403.1 237.9v86l-3.9 2.3v-86z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "v",
    d: "m484.5 273.4v125.6l-202.8-117v-125.7zm-81.4 50.5v-86l-42.2-24.4-4 2.3v86l42.2 24.4zm59.1 34.1v-86l-42.2-24.4-4 2.3v86l42.2 24.4zm-117-67.5v-86l-42.3-24.5-4 2.4v86l42.3 24.4z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m360.9 213.5l42.2 24.4-3.9 2.3-42.3-24.4z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m393.6 28.3v22.8l-24.4 8.3v-9.2-36z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m393.6 5.7q0 8.5 0 16.9l-14.6-8.4z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m392 244.5v64.5l-23.9-13.8v-64.5z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "r",
    d: "m393.6 0.1l24.4 14.1-24.4 14.1-24.4-14.1zm0 22.5l14.6-8.4-14.6-8.5-14.6 8.5z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m395.7 55.8l-151.7 66.7 125.2-72.3v9.2l24.4-8.3z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m368.1 230.7v64.5l-4.1 2.3v-69.1z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m392 309v4.7l-28-16.2 4.1-2.3z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "z",
    d: "m399.2 326.2l-42.3-24.4v-86l42.3 24.4zm-7.2-12.6v-69.1l-23.9-13.8-4.1-2.4v69.2z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m345.2 204.4v86.1l-4 2.2v-86z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m334 211v64.6l-23.9-13.8v-64.6z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m310.1 261.8l23.9 13.8v4.6l-27.9-16.1z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m306.1 264.1v-69.2l4 2.3v64.6z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "z",
    d: "m341.2 206.7v86l-42.2-24.4v-85.9zm-7.2 73.4v-69.2l-23.9-13.7v-0.1l-4-2.3v69.2z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m302.9 180l42.3 24.4-4 2.3-42.2-24.3z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "A",
    d: "m368.1 229.2c-3.3-2.2-11.2-6.4-11.2-6.4l-6.2 5.4-0.2 79c0 0-26.2-16.6-37-22.7-4.1-2.3-5.8-11.1-5.8-11.1l33.5 19.3v-80.3c0 0-23.9-12.7-31.5-17.1-0.9-0.5-10.7-5.9-10.7-5.9v7.8l-17.3-8.5v-32.5l202.8 117.2v-12.1l66.7-38.5c0 0 7.3 16.2 14.1 20.1 27 15.2 53.8 30.9 80.7 46.4 2.4 1.4 9.7 5.9 9.7 5.9v-12.1l140.4-81.1v12.1l-19.5 11.2v67.6c0 0 0.1 3.9 5.5 7 43.6 24.9 87.1 50.2 130.6 75.4 2.1 1.2 4 2.6 6.8 4.4-2.3 1.8-88.8 52.4-130.3 76.7-8.4 4.9-16.1 5.8-24.3 0.1-2.8-1.9-5.8-3.5-8.8-5.1-1.4-0.7-3.2-2-4.2-1.6-6.4 2.4-10.6-2-15.4-4.5-4.7-2.4-9.4-5-13.7-8-5.1-3.6-9.3-2.9-14.4 0.3-11.3 7-23 13.4-34.6 20.1-1.6 0.9-3.4 2.5-5 2.4-7.7-0.3-13.3 4.6-19.5 7.8-3.3 1.6-11.7 4.8-11.7 4.8v-9.9l18.1-10.4v-9.8l48-27.7c0 0-12.9-7.5-17.8-10.5-10.5 4.4-30.2 16.4-30.2 16.4v-5.9l26.3-14.8c0 0-13.1-8.6-18.4-11.9-3-1.8-5.3-3.4-3.5-7-5.4-2.2-9.8-1.3-14 1.1-7.2 4.3-14.4 8.4-22.1 12.9 0.3 2.4 0.7 7.6 0.7 7.6l-18.4 11.2c0 0 2.5 7 3.2 10.9-6 5.3-12.4 5.3-18.9 1.8-8.4-4.5-16.8-9.3-24.9-14.4-3.2-2-17.1-5.2-21.7-3.2v9.5c0 0-12.2 0.7-16.5 3.3-8.3 5-16.6 9.7-25 14.4-6.7 3.8-8.2 6.1-18 4.2 0-5.9 0-19.7 0-19.7 0 0 21.3-14 32.1-20.4q-0.3-0.9-0.5-1.9c-10.1 0-31.6 0.5-31.6 0.5 0 0-0.2-89.5-0.3-91.3-0.3-4.3-2.1-4.9-11.3-10.1-0.8-0.4-1.7-0.6-3.6-1.3-0.3 2.9 0.4 78.5 0.4 78.5 0 0-6.4-3.9-8.1-4.9-10.6-5.9-21-12.1-31.5-18.1-3.9-2.1-5.2-10.4-5.2-10.4l33.3 18.9-0.1-71 0.1-7.6-42.2-24.5c0 0-6.2 6.4-7.3 7.3 0 22.9 0 47.6 0 73.8-3.5-1.5-27.1-14.4-36.5-19.9-3.8-2.2-6.5-10.9-6.5-10.9l33.5 18.7v-78.8c0 0-23.9-14-31.1-18.2zm285.1 92.8c1.1-2.6 2.1-4.7 2.9-6.8-15-10.9-63.1-37.6-69.4-38.6-1.7 4.1-0.5 7.1 3.4 9.2 4.4 2.4 8.6 4.9 12.9 7.4 16.6 9.5 33.2 19 50.2 28.8z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m423.1 262.5l28 16.1v9.6c0 0-12.2-6.1-18.1-9 0 18 0.1 53.6 0.1 53.6l-10-1z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m364.1 228.4l27.9 16.1v9.6c0 0-12.2-6.1-18-9 0 18 0 53.6 0 53.6l-10-1z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m306.1 194.9l28 16.1v9.7c0 0-12.2-6.1-18.1-9 0 17.9 0.1 53.5 0.1 53.5l-10-1z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m393.6 51.1v-22.8l24.4-14.1v15.1l5.1 5.4z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m393.6 5.7v16.9l-14.6-8.4z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m483 239.9l-218.7-126.3 5.6-2.5 212.7 122.9z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m632.4 250.9l-91.5-52.8-3.1-7.5 87.6 50.6z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m600.8 207.2l-73.9-42.6-3.1-7.5 70 40.4z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m569.2 163.6l-56.3-32.5-3.1-7.5 52.4 30.2z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m537.6 119.9l-38.7-22.4-3.1-7.4 34.8 20.1z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m481.1 211.1l-189.6-109.5 5.6-2.4 183.6 106z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m479.1 182.3l-160.4-92.6 5.5-2.5 154.5 89.2z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m477.1 153.4l-131.2-75.7 5.5-2.4 125.3 72.3z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m475.1 124.7l-102-59 5.5-2.4 96.1 55.5z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m473.2 95.8l-72.9-42 5.5-2.5 66.9 38.7z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m471.2 67.1l-43.7-25.3 5.5-2.4 37.8 21.8z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m776.7 191.5l-132.1 76.2-2.9-3.9 130-75.1z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m725.9 163.9l-110.3 63.7-2.9-4 108.1-62.5z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m700.5 150.1l-99.5 57.4-2.9-4 97.3-56.2z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m675.1 136.3l-88.6 51.1-2.9-4 86.4-49.9z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m649.7 122.5l-77.7 44.9-2.9-4 75.5-43.7z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m624.3 108.7l-66.9 38.6-2.9-4 64.7-37.4z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m598.9 94.9l-56 32.3-2.9-4 53.8-31z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m573.4 81.1l-45 26-2.9-4 42.9-24.8z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m548 67.3l-34.2 19.7-2.8-4 32-18.5z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m522.6 53.5l-23.3 13.4-2.9-4 21.2-12.1z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m497.2 39.7l-12.4 7.2-2.9-4 10.3-5.9z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m543.6 204.6l-60.6 35-0.3-5.4 59.1-34.1z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m533.6 180.6l-52.5 30.3-0.4-5.4v-0.1l51-29.4z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m523.6 156.6l-44.5 25.6-0.4-5.4 43-24.8z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m513.3 132l-36.2 21-0.4-5.5 34.7-20z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m503.2 107.8l-28.1 16.2-0.4-5.4 26.6-15.4z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m493.4 84.2l-20.2 11.7-0.4-5.5 18.7-10.7z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m483.2 59.7l-12 7-0.4-5.4 10.5-6.1z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m469.2 38.3l-14.5-8.4 5.6-2.4 8.5 4.9z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m752 178.1l-121.5 70.1-2.9-4 119.4-68.9z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m256.9 443.3c0 0-4.1 5.6-7.6 7.6-3.4 1.9-6.8 6.1-2.6 9 4.1 2.9 5.3-4.6 11.4-6.1 6.1-1.5 6.1-2 6.1-7.3 0-3.4-1.4-3.2-1.4-3.2z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m280.9 456.2c0 0 0.1 5.3-1.1 8-1.1 2.7-2.1 9.3 1.1 10.1 3.2 0.8 10.2-0.2 6.5-18.1z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "m247.7 348.9c0 0-6.7 10.6-2 43.2 6.1 42.5 11.2 51.2 11.2 51.2 0 0 5.9 3.4 5.9 0-0.3-14.1-0.3-63.1-0.3-63.1 0 0 0.6-10.4 3.3 0 2.8 10.8 6.4 37.3 14.8 76.5 0 0 4 3.3 7.3 0 0 0-1.5-82.4-8.4-108.7-2.1-7.6-31.8 0.9-31.8 0.9z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m249.9 307c-5.7 5.4-14.6 12.9-21.6 16.6-1.7 1-3 1.5-4.8 2.2-7.1 2.6-14.1 4.5-20.7 6-1 0.2-1.9-0.4-2.1-1.4-0.2-0.8 0.3-1.7 1.1-2 6.9-2.7 14.6-6.4 21.3-10.5 6.4-4.2 14.2-12.5 18.9-18.2 1.9-2.3 5.3-2.5 7.6-0.7 2.4 2 2.6 5.7 0.3 8z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m302.5 329.3c1.9 6.7 1.8 11.1 0.6 15.3-2.1 7.9-7.2 18-11.4 25.1-0.4 0.8-1.5 1.1-2.4 0.6-0.7-0.5-1-1.4-0.7-2.2 2.9-6.9 7.8-20.3 7.7-27.7-0.2-5.4-3.6-11.5-6.8-15.9-0.4-0.7-1.6-2.2-1.7-2.3-2.3-2-2.7-5.4-0.8-7.7 2.4-2.8 6.8-2.6 8.8 0.4 3 4.6 5.4 10.1 6.7 14.4z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "E",
    d: "m274.6 297c-8.9-2.2-20.2-4.9-24.1-4.4-3.9 0.5-16.3 9-18.1 15.8 0 0 1.3 6.9 8.1 9.6l5.1-3.2c0 0-2.6 31.3 0.3 36.4 3 5.1 16.6 7.3 22 6.1 5.3-1.2 13.7-6.6 13.7-6.6l0.5-28.3c0 0 3.5 3.4 7.4 5.5 3.9 2.2 11.2-4.3 11.2-7.8 0 0-13.4-20-26.1-23.1z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m204 329.7c0.1 2.8-2.9 5.2-6.9 5.4-3.9 0.2-7.2-1.9-7.4-4.7-0.1-2 5-1.5 7.5-2.4 0.8-0.3-1.6-2.9-0.6-3 3.9-0.2 7.3 1.9 7.4 4.7z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "E",
    d: "m204 326.4l1.7 6.4c0 0 31.3-9.2 39.9-18 8.6-8.9-11.6-9.7-11.6-9.7 0 0-18.5 16.2-30 21.3z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "F",
    d: "m272.5 300.7c0 3.4-3.6 6.2-8.1 6.2-4.4 0-8-2.8-8-6.2 0-3.4 3.6-6.2 8-6.2 4.5 0 8.1 2.8 8.1 6.2z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "G",
    d: "m264.9 304.2c-3.5 0-6.3-2.7-5.6-5.6l3.7-16.9c0.6-2.6 3.5-4.3 6.7-3.8 3.1 0.5 5.2 3 4.6 5.6l-3.7 16.8c-0.5 2.3-2.9 3.9-5.7 3.9z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m258.2 275.6c0 0-4.5 17.8 0.2 21 4.8 3.2 11.6-0.5 15.4-6.2 0 0 0.8-1.9 2.2-2.9 3-1.9 5.3-11.3-1.1-13.6-9.9-3.6-16.7 1.7-16.7 1.7z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "H",
    d: "m255.2 271.7c0 0 2.1 6.9 9.1 6.7 6.9-0.1 8 0.9 9 2.6 1 1.8 1.4 5.7 1.4 5.7 0 0 2.2-4.4 3.6-3.7 1.4 0.6 3-3.3 2-8-1.9-9.1-30.3-17-25.1-3.3z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "F",
    d: "m259.2 305.4l1.6 13.6 5-12.1z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "H",
    d: "m308.6 356.2l-32 18.5c-1.8 1.1-3.4 0.4-3.4-1.5v-18.8c0-1.8 1.6-4.2 3.4-5.3l32-18.5c1.9-1.1 3.4-0.4 3.4 1.5v18.8c0 1.8-1.5 4.2-3.4 5.3z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m292 366.4c2.3 1.7 1.8 4.3-3.1 6.8-4.6 2.3-7.2 1.5-9.4-0.2 0 0 4.6-2.8 5.8-3.8 0.7-0.6-1.7-3.4-0.7-3.5 2-0.2 5.2-0.9 7.4 0.7z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "E",
    d: "m286.3 325.5c0 0 9.1 10.4 8.8 14.3-0.1 3.4-4.7 19-6 23.4-0.3 1-0.1 2.1 0.4 2.9 0.8 1.1 2.3 2.3 4.9 1.5 4.7-1.5 10.7-23.8 12-29 2.4-10.2-5.7-18.5-5.7-18.5 0 0-20-6.5-14.4 5.4z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m141.6 595.4c0 0 37.6 15.3 47.6 16.4 10.1 1.1 31.3 2.4 41-3.3 9.8-5.7 8.2-14.5-1.3-19.9-5.6-3.1-32.7-6.1-54.5-0.2-11.8 3.2-1.9 8-32.8 7z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m128.5 570.3c-0.4-10.2 11.7-19.3 29.1-21.7 8.5-1.2 17.7-0.7 26 1.8 0 0.1-4.2 0.3-9.2 2.1-6.1-1-12.8-0.9-19.1 0.5-5.6 1.3-11.7 3.7-15.8 7.7-6.2 6.1-5.6 13.7 1.3 19.4 4.5 3.7 10.5 5.9 16.1 6.9 0.3 0.8 0.8 2.1 0.9 2.4 0.4 0.8 0.8 1.5 0.9 1.8-7.7-0.9-16.1-3.4-22.4-8.1-2.3-1.8-4.4-3.9-5.9-6.4-1.2-2.2-1.8-4.3-1.9-6.4z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "I",
    d: "m158 570.2q-0.6 2.1-1.1 4.2-0.8-0.9-0.6-2 0.2-1 1.7-2.2z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "I",
    d: "m156.9 587c-5.6-1-11.6-3.2-16.1-6.9-6.9-5.7-7.5-13.3-1.3-19.4 4.1-4 10.2-6.4 15.8-7.7 6.3-1.4 13-1.5 19.1-0.5-7.4 2.7-13.9 8-15.9 15.7q-0.2 0.7-0.4 1.5-1.5-0.6-2.9-1.2-2.1 1.3-2.6 2.8-0.6 1.4 0.1 2.5 0.6 1.2 2.4 2.5-1.4 0.8-2.8 1.6 0.9 0.5 1.7 1 1.1-0.6 2.1-1.3c0 0.1 0 0.4 0 0.5-0.3 2.5-0.2 4.9 0.4 7.4 0.2 0.6 0.4 1.3 0.4 1.5z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m158.1 569.7q-0.1 0.2-0.1 0.5-1.5 1.2-1.7 2.2-0.2 1.1 0.6 2c-0.5 1.7-0.5 1.7-0.8 3.2q-1 0.7-2.1 1.3-0.8-0.5-1.7-1 1.4-0.8 2.8-1.6-1.8-1.3-2.4-2.5-0.7-1.1-0.1-2.5 0.5-1.5 2.6-2.8 1.4 0.6 2.9 1.2z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "I",
    d: "m128.5 579.5c0-0.4 0 0.2 0-9.2 0.1 2.1 0.7 4.2 1.9 6.4 1.5 2.5 3.6 4.6 5.9 6.4 6.3 4.7 14.7 7.2 22.4 8.1 1.5 2.8 3.7 5.6 5.5 7.5 0.7 0.7 1.4 1.4 2.1 2-11 0-24.6-3.1-32.4-10.7-2.9-2.8-5.2-6.4-5.4-10.5z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "I",
    d: "m221.4 569.6c7.3 9.8 5.4 21-5 27-10.4 6.1-27.4 5.2-39.9-3.5-6.7-4.6-10.2-10.2-11.5-15-1.2-5-0.2-9.6 2.4-13.4 2.8-4.1 8.3-7.9 16.4-9.2 14.1-2.3 30 3.9 37.6 14.1zm-11.7 10.6q2.3-1.8 2-4.2-0.2-1.9-2.3-4.2 0.7-0.3 1.3-0.7-0.7-0.7-1.5-1.4-0.7 0.3-1.4 0.7-2.9-2.2-5.5-2.7-3.9-0.7-6.9 1c-2 1.2-3.1 3-2.3 5.3q0.7 2.1 2 3.8-4.4 2.5-8.8 5.1-1.5-1.5-1.1-3.4 0.3-1.3 2.2-2.9-1.6-1-3.2-2.1-2.1 1.4-2.6 3.1-0.6 1.7 0 3.2 0.6 1.5 2.3 3.4-1.4 0.9-2.8 1.7 0.8 0.7 1.6 1.4 1.4-0.9 2.8-1.7 3 2.5 6.7 2.9 3.7 0.5 6.6-1.2c1.5-0.9 2.7-2.2 2.8-4q0-1.2-0.7-2.6-0.4-0.8-1.9-2.9 4.1-2.3 8.1-4.6c1.4 1.9 1.1 3.4-0.6 4.8q1.6 1.1 3.2 2.2z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "k",
    d: "m211.7 576q0.3 2.4-2 4.2-1.6-1.1-3.2-2.2c1.7-1.4 2-2.9 0.6-4.8q-4 2.3-8.1 4.6 1.5 2.1 1.9 2.9 0.7 1.4 0.7 2.6c-0.1 1.8-1.3 3.1-2.8 4q-2.9 1.7-6.6 1.2-3.7-0.4-6.7-2.9-1.4 0.8-2.8 1.7-0.8-0.7-1.6-1.4 1.4-0.8 2.8-1.7-1.7-1.9-2.3-3.4-0.6-1.5 0-3.2 0.5-1.7 2.6-3.1 1.6 1.1 3.2 2.1-1.9 1.6-2.2 2.9-0.4 1.9 1.1 3.4 4.4-2.6 8.8-5.1-1.3-1.7-2-3.8c-0.8-2.3 0.3-4.1 2.3-5.3q3-1.7 6.9-1 2.6 0.5 5.5 2.7 0.7-0.4 1.4-0.7 0.8 0.7 1.6 1.4-0.7 0.4-1.4 0.7 2.1 2.3 2.3 4.2zm-13.9 0.2q3.9-2.2 7.7-4.4c-4.2-2.9-8.4-1.1-8.8 1.2q-0.2 1.3 1.1 3.2zm-0.2 6.7q0.2-1.2-1.3-3.5-4.2 2.4-8.5 4.9 1.8 1.3 4 1.5 2.3 0.2 4.1-0.8 1.5-0.9 1.7-2.1z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "k",
    d: "m161.4 561.9c3.5-5.1 10.2-9.6 19.9-11.2 17-2.8 36.4 4.6 45.7 17.2 8.9 11.9 6.5 25.5-6 32.8-12.6 7.3-33.2 6.3-48.5-4.3-8.1-5.6-12.4-12.4-13.9-18.3-1.5-5.9-0.4-11.6 2.8-16.2zm55 34.7c10.4-6 12.3-17.2 5-27-7.6-10.2-23.5-16.4-37.6-14.1-8.1 1.3-13.6 5.1-16.4 9.2-2.6 3.8-3.6 8.4-2.4 13.4 1.3 4.8 4.8 10.4 11.5 15 12.5 8.7 29.5 9.6 39.9 3.5z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "I",
    d: "m158.1 569.7q0.1 0 0.1 0c-0.5 2.7-0.4 5.5 0.4 8.4 1.5 5.9 5.8 12.7 13.9 18.3 15.3 10.6 35.9 11.6 48.5 4.3 5.6-3.3 9.2-7.8 10.6-12.9q-1 3.6-1.9 7.2c0 0.1-0.7 2.9-2.5 5.6-0.3 0.6-1.2 1.7-1.3 1.8-3.8 4.7-9.6 7.7-15.4 9.2-16.1 4.1-35.6-1.8-46.3-12.9-2.2-2.2-4.5-5.4-5.7-7.8-1.3-2.6-2.3-5.8-2.5-8.9-0.1-1.4-0.1-2.6 0.1-3.9 0.2-2 0.5-2.7 2-8.4z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "I",
    d: "m205.5 571.8q-3.8 2.2-7.7 4.4-1.3-1.9-1.1-3.2c0.4-2.3 4.6-4.1 8.8-1.2z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "I",
    d: "m196.3 579.4q1.5 2.3 1.3 3.5-0.2 1.2-1.7 2.1-1.8 1-4.1 0.8-2.2-0.2-4-1.5 4.3-2.5 8.5-4.9z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m131.3 494.4c0 0-0.7 4.5-1.4 6.5-0.7 1.9-0.7 7 3.3 6.5 1.8-0.3 4-2.8 6.3-4 2.7-1.4 6.7-2.7 7.9-3.6 2.3-1.7 1.7-2.7 0.3-4.5-0.6-0.9-3.5 0.3-5.5 0.8-2.6 0.7-5.5-0.2-7.2-2.4z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m153.6 506.3c0 0-3.2 9.3-1.5 10.5 1.7 1.3 7.5-0.8 11.5 0 4 0.9 10.8 0.4 11.5-1.5 0.7-1.9-1.8-2.9-9.1-5.4-7.4-2.5-8.5-6-8.5-6z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m135.3 400.7c0 0-1.8 16.4-2.1 30.3-0.4 13.8-3.7 21.3-3.7 27.2 0 5.8-1.4 36.6 1.4 37.7 0.9 0.3 1.7 0.6 2.5 0.7 1.5 0.4 3-0.6 3.3-2.1l19.4-82.1z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "K",
    d: "m134.8 391.9c0 0-3.6 11.1 0 13.3 3.6 2.2 16.9 11.9 16.9 11.9 0 0 0.5 29.4 0 36.1-0.6 6.6-1.2 15.6-0.1 27 1.1 11.4 2.5 25 2 26.1-0.5 1.1 2.5 2 5 1.1 2.5-0.8 18.9-90.8 17.5-107.8-1.4-16.9-41.3-7.7-41.3-7.7z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m165 336.7l-3.2-3.5 1.6-2.6c0 0 3.5 2.5 5.3 0 1.8-2.5 2.6-20.3-1.1-23.8-3.7-3.5-15.5 1.7-15.5 8.1 0 6.4 3.6 15 0.6 16.1-3.1 1.1-3.4 4-3.4 4z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m165.6 299.9c0 0 5.6 1.1 5 6.9-0.7 5.8-7.5 11.7-10.6 12-3 0.3 1 6.8-1.5 9.1-2.5 2.4-5.4 3.4-8.3-0.9-3-4.3-3-4.3-3-4.3 0 0-5.5-8.7-0.7-14.9 4.9-6.3 6-12 19.1-7.9z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m136.2 352.9c-4.3 9.1-8.9 27.5-9.6 37.6-0.1 0.6-0.1 1.3-0.1 1.9 0 1.1 0 0.4 0 1.9 0 0.6 0 1.3 0 1.9l0.2 1.9c0.4 4.4 1.4 7.7 1.4 7.6 0.2 0.7-0.2 1.4-0.9 1.6-0.6 0.1-1.2-0.1-1.5-0.6-1.3-2.5-2.4-5.1-3.2-7.8-0.8-2.9-0.7-2.3-1.2-5.2-2.3-11.9 0.4-25.2 3.5-36.5 2-7 4-11.8 6-15.6 1.3-2.4 2.9-4.9 4.7-7 1.4-1.8 4-2 5.8-0.5 1.3 1.1 1.7 2.9 1.2 4.5-1 2.7-4.9 11.1-6.3 14.3z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m152.7 331c0 0-11.4-2.9-14.2 1.1-2.8 4-5.5 61-4.1 64.2 1.3 3.2 20.3 18 30.5 14.4 10.1-3.6 11.2-11.1 11.2-11.1l-1.4-34.9c0 0 4.6-0.6 6.1-3.3 1.5-2.8-2.2-15.1-7.5-19.6-5.3-4.4-20.6-10.8-20.6-10.8z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m134.4 334.4c-4 2.4-10 13.5-8 17.7 0.8 1.9 4.9 3.2 7.6 4.4 9.1 4.1 9.8-23.7 9.8-23.7-2.1-1.3-3.2-2-5.3-0.7z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m124.2 409.9c-1.5-2.9-0.9-6.2 1.3-7.3 2.2-1.1 5.8-0.2 7.4 4.6 0.2 0.7-3.5-1.9-3.4-1.1 0.4 2.1 3.2 7.1 1.6 7.9-2.2 1.1-5.4-1.2-6.9-4.1z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m206.6 355.6c0.5-0.6 0.2 4.4 0.8 4 1.8-1.2 5-6.5 6.5-5.4 1.9 1.6 1.1 6.4-0.9 9-2 2.5-5.2 3.4-7.1 1.9-1.9-1.6-1.3-6.9 0.7-9.5z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m175.4 383.1c0 0-5.9-7.2-7.3-14.5-1.3-7.1-0.5-14.5-0.5-14.5l7.4 16.5z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m179.9 354.7c0 0.3 0.2 2.4 0.2 3.1 0.7 5.1 2.5 13.1 6.7 16 0.1 0.1 0.3 0.2 0.5 0.3 0.1 0.1 0.3 0.2 0.4 0.2 0.1 0.1 0.1 0.1 0.2 0.1q0.1 0.1 0.1 0.1 0.1 0 0.2 0c0.5 0.1 1.4-0.1 2.2-0.4 6-2 14.4-10.2 18.9-14.5 0.7-0.7 1.7-0.7 2.4 0 0.6 0.6 0.6 1.6 0.1 2.2-4.3 5.5-9.5 12-15.1 16.3-2.4 1.8-5.2 3.4-8.2 3.7-0.9 0-0.7 0-1.5 0-0.5-0.1-1-0.2-1.6-0.3-1.3-0.4-1.8-0.6-2.3-0.9-8.1-3.9-12.4-15.3-14.2-24.1-0.1-0.7-0.2-1.7-0.2-1.6-0.5-3.1 1.6-6 4.7-6.4 3.6-0.6 6.9 2.4 6.5 6.2z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m169.5 367.7c0 0 5 1 8.5 0 2.7-0.7 4.3-5 4.3-5 0 0 1.3-11.5-5.5-16.5-6.8-5.1-12.2 5.7-7.3 21.5z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "L",
    d: "m571 477.8l-9.3 5.3-1.1 0.7-23.4 13.5-0.9-2.5 64.7-37.4 0.8 2.6-16.5 9.5z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "L",
    d: "m600.9 445.1l0.3 2-13 9.8-2.9-0.1z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m600.9 445.1l-15.6 11.7-52-30.1 15.5-11.7z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m585.3 456.8l2.9 0.1 12.8 0.5-64.7 37.4-15.7-0.7 64.7-37.3z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "N",
    d: "m585.3 492.2l-1 0.6c-0.1-6.9-3.2-10.3-5.9-12.4-2-1.4-3.8-2.2-7.4-2.6l14.3-8.3z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "O",
    d: "m584.3 492.8c0 2.5-0.4 5.5-1.3 9.1l-9.3 5.3c3.5-13.1-0.9-18.6-4.7-21.4-1.9-1.5-3.7-2.2-7.3-2.7l9.3-5.3c3.6 0.4 5.4 1.2 7.4 2.6 2.7 2.1 5.8 5.5 5.9 12.4z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "P",
    d: "m581.4 456.8l-14.8 8.5c-3.1-2.7-6.1-5.7-9-7.1-2-1-4-1.2-5.9-1.5v-15.4l-18.4-10.6q0-0.9 0-1.7z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m574.4 498.6c0-3.6-0.7-7-2.9-9.7-1.2-1.6-3.3-3.2-5.3-4-1.7-0.7-3.7-0.9-5.6-1.1l1.1-0.7c3.6 0.5 5.4 1.2 7.3 2.7 3.8 2.8 8.2 8.3 4.7 21.4l-0.6-0.5c0.7-2.6 1.2-5.4 1.3-8.1z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "R",
    d: "m533.3 467.3q9.2-5.3 18.4-10.6c1.9 0.3 3.9 0.5 5.9 1.5 2.9 1.4 5.9 4.4 9 7.1l-46 26.6-12-7q9.4-5.3 18.7-10.7v-5.8l-12.9-7.4q0.2-0.2 0.4-0.3 1.5-0.8 2.9-1.7 0.2-0.1 0.3-0.1c3.2-1.6 6.6 4.9 11 7.2 1.4 0.7 2.8 1 4.3 1.2z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m551.7 456.7q-9.2 5.3-18.4 10.6v-15.3l18.4-10.7z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m548.4 507.4v3.1l-9.7 5.6v-3z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m548.4 503.2v3.1l-9.7 5.6v-3z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m548.4 498.9v3.1l-9.7 5.6v-3z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m537.5 505.3v11.5l-14.9 8.6v-11.4z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m533.3 426.7l52 30.1-64.7 37.3-52-30zm33.3 38.6l14.8-8.6-48.1-27.8-60.8 35.1 8.4 4.9 22.8 13.1 5 2.9 11.9 6.9z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m518 458.9q-0.1 0-0.3 0.1-1.4 0.9-2.9 1.7v-19.4l18.5 10.7v15.3c-1.5-0.2-2.9-0.5-4.3-1.2-4.4-2.3-7.8-8.8-11-7.2z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m533.3 430.7l18.4 10.6-18.4 10.7-18.5-10.7z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "L",
    d: "m533.3 429q0 0.8 0 1.7l-18.5 10.6v19.4q-0.2 0.1-0.4 0.3l-9.9-5.7-23.6 13.6-8.4-4.8z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m517.5 409.2l15.8 17.5-64.7 37.4-15.7-17.5 11.7-6.8 0.5-0.3 9.3-5.4 1.2-0.6 0.4-0.3 9.4-5.4z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m527.3 474.2q-9.3 5.4-18.7 10.7l-4.9-2.8 23.6-13.7z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "Y",
    d: "m527.3 468.4l-23.6 13.7-22.8-13.2 23.6-13.6 9.9 5.7z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "N",
    d: "m574.4 498.6l-53.8 31v-35.5l0.7 2 0.1 0.5 15.8 0.7 23.4-13.5c1.9 0.2 3.9 0.4 5.6 1.1 2 0.8 4.1 2.4 5.3 4 2.2 2.7 2.9 6.1 2.9 9.7zm-36.9 6.7l-14.9 8.7v11.4l14.9-8.6zm10.9 2.1l-9.7 5.6v3.1l9.7-5.7zm0-4.2l-9.7 5.7v3l9.7-5.7zm0-4.3l-9.7 5.7v3l9.7-5.6z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "P",
    d: "m520.6 494.1l15.7 0.7 0.9 2.5-15.8-0.7-0.1-0.5-0.7-2z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "P",
    d: "m520.6 497.2v32.4l-52-30.1v-9.5l41.6 24z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "L",
    d: "m520.6 494.1v3.1l-10.4 16.8-1.3-1z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "O",
    d: "m475.5 423.2c1.1-0.7 2.5-0.4 3.9 0.2 1.7 0.7 3.3 1.8 6 4.4l-9.4 5.4c-2.6-2.6-4.2-3.7-5.9-4.4-1.3-0.6-2.7-0.9-3.8-0.3q4.6-2.7 9.2-5.3z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "Z",
    d: "m474.2 432.2q0.1 0.9 0.2 1.9l-9.3 5.4c-0.3-2.5-0.7-6.9 0.5-9.1 1-1.8 2.7-1.7 4.6-0.9 1.5 0.6 2.8 1.6 4 2.7z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m520.6 494.1l-11.7 18.9-40.3-23.2-11.8-6.8 10.9-17.5 0.9-1.4z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "P",
    d: "m452.9 446.6l15.7 17.5-0.9 1.4-15.7-17.3z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m476 433.2l-0.4 0.3q-0.7-0.7-1.4-1.3c-1.2-1.1-2.5-2.1-4-2.7-1.9-0.8-3.6-0.9-4.6 0.9-1.2 2.2-0.8 6.6-0.5 9.1l-0.5 0.3c-1-7.3-0.1-10.3 1.6-11.2q0-0.1 0.1-0.1c1.1-0.6 2.5-0.3 3.8 0.3 1.7 0.7 3.3 1.8 5.9 4.4z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "L",
    d: "m510.2 514l-41.6-24v-0.2l40.3 23.2z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "L",
    d: "m468.6 489.8v0.2l-10.5-6.1-1.3-0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "a0",
    d: "m533.2 428.9l0.8 2.2c0 0-1.4 0.5-18.6 10.4 1.7 5.8 5.2 17.6 5.2 17.6l-1.7 0.7-2.3 1.4-2.2-0.2-6.6-3.8-22.4 13h-2.2l-10.7-6.1z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "a0",
    d: "m533.3 467.3v-15.3l18.4-10.7c0 0 3.9 12.1 4.9 16.3-1.2 0.9 1.7-0.9-12.8 7.5-0.6 0.3-1.3 0.5-2 0.6-2.5 0.4-8.5 1.6-8.5 1.6z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "a0",
    d: "m530.9 473.8l-20.7 12-6.5-3.7 23.6-13.7v3.8z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "a0",
    d: "m465.2 439.4c-0.1-0.5-0.2-0.9-0.2-1.4-0.2-2-0.4-5.3 0.5-7.3 0.6-1.4 1.7-1.9 3.2-1.6 2.4 0.1 5.5 3.1 5.5 3.1l0.2 1.9c0 0-8.1 4.8-9.2 5.3z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "a0",
    d: "m601 445.2c0.1 0.1 0.1 0.1 0.1 0.1 0.4 1.6 0.4 1.6-0.9 2.6q-5.4 4-10.8 8.1c-0.7 0.5-1.3 0.8-2.2 0.7-0.4 0-0.8 0-1.2 0 0-0.2-0.1-0.2-0.1-0.3 0.1-0.1 0.4-0.3 14.7-11.1 0.1 0 0.2-0.1 0.4-0.1z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a0",
    d: "m601.2 519.4c3.5 1.6 6.4 2.8 9 4.9 0.4 0.3 0.7 0.7 1 1.1 0.3 0.4 0.3 0.6-0.2 1-0.7 0.5-4.1 2.3-8.8 5.1-1.1 0.7-2.3 0.7-3.5 0.7-2.4-0.2-4.8-0.5-7.2-0.7-0.2-0.1-0.5-0.2-1-0.3 2.1-1.4 4.1-2.5 6.2-3.7-0.2-0.2-0.4-0.4-0.6-0.5-1.2-0.6-2.5-1.1-3.8-1.8-0.6-0.3-1-0.1-1.5 0.2-2.6 1.5-22.4 12.9-23.1 13.3-0.6 0.4-1.1 0.4-1.7 0.1q-5.6-2.3-11.2-4.7c-10.1-4.2-7.4-3-9.8-4.2-3.6 1.2-13.6 4.5-18.5 6.2-0.8 0.2-1.4 0.2-2.1-0.2-10.9-6.4-45.7-26.4-50.3-29.1-0.3-0.2-0.8-0.3-0.8-0.9 0.1-0.5 0.6-0.5 0.9-0.6q1.3-0.5 2.7-1c-0.8-3.7-1.7-7.2-2.4-11.1 2.2 1.2 9.2 5.4 34.4 19.8 3.9-6.2 11.7-18.7 11.7-18.7l0.8 2.3 15.7 0.7-0.8-2.5 64.7-37.4 0.8 2.6-6.9 4c0 0-2-1.2 21.6 12.5 12.1 6.9 10 5.7 11.6 6.7-5.9 3-11.6 6-17.5 9 4.5 1.9 3 1.2 21.4 9 0 0.5-0.5 0.6-0.8 0.8-9 5.3-28.1 16.2-30 17.4zm-38.8-36.1c0 0 0.2 0.4 0.2 0.5 1.5 0.4 2.8 0.6 4.1 1.2 7.9 3.7 8.9 11.5 6.9 19.9q-0.1 0.8-0.3 1.5c0 0.3-0.1 0.7 0.4 0.8 1.3-4.8 1.9-10.2 0.3-14.7 3.2-1.9 6.3-3.4 9.4-5.3-2.8-8.1-10.6-9.2-11.4-9.3-0.8-0.1-0.5 0-1 0.2-0.7 0.5-8.6 5.2-8.6 5.2z"
  }))), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "N",
    d: "m463.2 502.3v46.7l-19.8 11.4v-46.7z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m463.2 502.3l-19.8 11.4-19.7-11.4 19.7-11.4z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "m443.4 513.7v46.7l-6.7 3.9v-46.7z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "O",
    d: "m443.4 490.9l-19.7 11.4-6.8-3.9 19.8-11.4z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "a2",
    d: "m443.4 513.7l-6.7 3.9-19.8-11.4 6.8-3.9z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "N",
    d: "m436.7 517.6v46.7l-19.8 11.4v-46.7zm-6.4 48.4v-7.7l-11.6 6.7v7.8z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m436.7 517.6l-19.8 11.4-19.7-11.4 19.7-11.4z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m436.7 487l-19.8 11.4-19.7-11.4 19.7-11.4z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m430.3 558.3v7.7l-11.6 6.7v-7.7z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "a2",
    d: "m416.9 498.4l6.8 3.9-6.8 3.9-6.7-3.9z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "P",
    d: "m416.9 529v46.7l-19.7-11.4v-46.7z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "a2",
    d: "m416.9 498.4l-6.7 3.9-19.8-11.4 6.8-3.9z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "O",
    d: "m416.9 506.2l-19.7 11.4-6.8-3.9 19.8-11.4z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m410.2 502.3l-19.8 11.4-19.8-11.4 19.8-11.4z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "O",
    d: "m397.2 517.6v46.7l-6.8-3.9v-46.7z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "P",
    d: "m390.4 513.7v46.7l-19.8-11.4v-46.7z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "N",
    d: "m524.9 543.7v46.6l-27 4.2v-46.7z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m520.5 534.2l4.4 9.5-27 4.1-4.4-9.4z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "O",
    d: "m520.5 534.2l-27 4.2-2.5-5.4 27-4.1z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m518 528.9l-27 4.1-4.4-9.4-9.2 1.4 36.2-5.6z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "m497.9 547.8v46.7l-9.3 1.4v-46.6z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "a2",
    d: "m493.5 538.4l4.4 9.4-9.3 1.5-4.3-9.5z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "a2",
    d: "m491 533l2.5 5.4-9.2 1.4-2.5-5.3z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "a2",
    d: "m486.6 523.6l4.4 9.4-9.2 1.5-4.4-9.5z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "N",
    d: "m488.6 549.3v46.6l-27 4.2v-46.7zm-8.7 46.1v-7.7l-15.8 2.4v7.8z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m484.3 539.8l4.3 9.5-27 4.1-4.4-9.4z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "O",
    d: "m481.8 534.5l2.5 5.3-27.1 4.2-2.4-5.4z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m477.4 525l4.4 9.5-27 4.1-4.4-9.4z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m479.9 587.6v7.8l-15.8 2.4v-7.7z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "P",
    d: "m461.6 553.4v46.7l-4.4-9.5v-46.6z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "O",
    d: "m457.2 544v46.6l-2.4-5.3v-46.7l2.4 5.4z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "P",
    d: "m454.8 538.6v46.7l-4.4-9.5v-46.6l4.4 9.4z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "N",
    d: "m411.3 572.8v19.7l-26 4.1v-19.8z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m407.1 563.6l4.2 9.2-26 4-4.2-9.1z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "a2",
    d: "m407.1 563.6l-26 4.1-2.4-5.2 26-4z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m400.5 549.4l4.2 9.1-26 4-4.3-9.1z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "m385.3 576.8v19.8l-8.9 1.3v-19.7z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "O",
    d: "m381.1 567.7l4.2 9.1-8.9 1.4-4.2-9.2z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "O",
    d: "m378.7 562.5l2.4 5.2-8.9 1.3-2.4-5.1z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "O",
    d: "m374.4 553.4l4.3 9.1-8.9 1.4-4.2-9.1z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m376.4 578.2l-26 4-4.2-9.1 26-4.1z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "a2",
    d: "m372.2 569l-26 4.1-2.4-5.2 26-4z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m365.6 554.8l4.2 9.1-26 4-4.2-9.1z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "N",
    d: "m376.4 597.9l-26 4.1v-19.8l26-4zm-8.4 0.5v-6.6l-15.3 2.4v6.5z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m368 591.9v6.5l-15.3 2.4v-6.6z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "P",
    d: "m350.4 582.2v19.8l-4.2-9.2v-19.7z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "O",
    d: "m346.2 573.1v19.7l-2.4-5.1v-19.8l2.4 5.2z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "P",
    d: "m339.6 558.8l4.2 9.1v19.8l-4.2-9.1z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "a3",
    d: "m350.4 582.2v19.8l41.9 4.6 32.2-10v-11.9l28.2-3.8-2.3-5.1v-46.6l13.3-2.1-0.5-24.8-46.3 26.7v46.7l-16.4-26.3 10.8 23.4z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "a3",
    d: "m461.6 553.4v46.7l100.4-5.6-37.1-21.2v-29.6z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "a4",
    d: "m848.7 480.1l-216.2 124.8-88.3-50.9 216.3-124.8z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "a5",
    d: "m848.7 480.1v98.5l-39.1 22.5-177.1 102.3v-98.5z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "a6",
    d: "m632.5 604.9v98.5l-79-45.6h-0.1l-9.2-5.3v-98.5z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "a7",
    d: "m608.1 718.8l0.2 0.1v9.3l-0.2 0.1-72-41.6v-9.5h0.1z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "a8",
    d: "m632.5 714.1l173.3-100.1 13.1-7.5v9.5l-13.1 7.6-173.3 100z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "a8",
    d: "m632.5 714.1v9.5l-24.2 4.6v-9.3l-0.2-0.1z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "a9",
    d: "m805.8 614l-173.3 100.1-24.4 4.7-71.9-41.6 8-14 9.2-5.4h0.1l79 45.6 177.1-102.3 9.3 5.4z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "m567.8 698.1l0.5 20.7-1.4 0.4 0.4-20c0-2-2-4.6-5.3-5.1l-10.5-1.7v-1.2l9.5 1.4v0.1l1.6 0.2c3.1 0.5 5.2 3 5.2 5.2z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "m608.3 718.7v9.4l-0.1 0.1h0.1l-9.1 5.3v-19.5l9.1-5.3v9.8l-0.1 0.1z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "m608.3 700.6v8.1l-9.1 5.3v-8.2z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "m608.3 700v0.6l-9.1 5.2v-54.6l9.1-5.3z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "m600.7 634.1l7.6 11.8-9.1 5.3-7.6-11.8z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "m599.2 714v19.5l-18.7 10.8-0.1-0.1c-1.5-0.9-3.1-1.8-4.6-2.6v-0.1c-4.2-2.4-9.8-1.4-14.8 1.5v-7z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "m599.2 705.8v8.2l-38.2 22v-8.1z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "m599.2 651.2v54.6l-38.2 22.1v-6.7l1 0.2c2.4 0.3 4.2-0.6 4.9-2.1v-0.1q0.3-0.6 0.6-1.1c0.2-0.5 0.3-1 0.3-1.5v-18.5c0-2.2-2.1-4.7-5.2-5.2l-1.6-0.2v-0.1-19.3z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "m591.6 639.4l7.6 11.8-38.2 22.1-7.6-11.9z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "a9",
    d: "m587.4 755.6q-1.2 0.8-2.4 1.4c-0.3-2.4-1-5-2.6-6.9-1.6-1.9-4-3.2-6.5-3.5-1.2-0.1-2.5 0-3.7 0.3-2.9 0.6-5.8 2.2-8.3 4.1-1.3 0.9-2.4 1.9-3.4 2.9-6.3 6.2-11.2 15.4-12.1 24.2-0.7-0.4-1.4-0.7-2-1.1q0.6-3.9 2-7.6c2.4-6.6 6.5-12.9 11.3-17.6 4.4-4.4 11.4-9.1 17.5-8.3 1.1 0.2 2.2 0.5 3.1 0.9 1.7 0.7 3.2 1.9 4.3 3.3 1.7 2.2 2.5 5.2 2.8 7.9z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "m572.2 746.9c1.2-0.3 2.5-0.4 3.7-0.3 2.5 0.3 4.9 1.6 6.5 3.5 1.6 1.9 2.3 4.5 2.6 6.9q-2.3-1.3-4.7-2.7c-0.2-0.7-0.5-1.4-0.9-2-1.1-1.8-2.8-3.2-4.8-3.8-3.5-1-7.3 0.2-10.7 2.5 2.5-1.9 5.4-3.5 8.3-4.1z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ag",
    d: "m580.3 754.3c0.6 1.8 0.9 3.7 0.9 5.5 0 9-5.9 21.2-14.7 27.2-3.3 2.3-7.5 4.2-11.1 3.1-0.7-0.2-1.4-0.5-2.1-0.9-1.7-1.2-3.2-3.1-4-5-0.7-1.8-0.9-3.8-0.9-6.1 0.9-8.8 5.8-18 12.1-24.2 1-1 2.1-2 3.4-2.9 3.4-2.3 7.2-3.5 10.7-2.5 2 0.6 3.7 2 4.8 3.8 0.4 0.6 0.7 1.3 0.9 2zm-2.9 7.7c0.1-4.3-1.6-7.4-4.5-8.6-1.5-0.6-3.3-0.6-5.4 0-2.2 0.7-4.6 2.2-7.1 4.7-4.3 4.4-7.3 10.2-8.1 16.5-0.2 1.7-0.2 3.4 0.1 4.9 0.2 0.9 0.4 1.7 0.9 2.5 0.5 0.9 1.1 1.6 1.7 2.2 7.3 6 22.1-7.7 22.4-22.2z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "m580.5 744.3l-0.2 0.1c-0.9-0.4-2-0.7-3.1-0.9-6.1-0.8-13.1 3.9-17.5 8.3-4.8 4.7-8.9 11-11.3 17.6v-3.4l-4.4-2.5c4-7.3 10.2-15.8 17-20.5 5-2.9 10.6-3.9 14.8-1.5v0.1c1.5 0.8 3.1 1.7 4.6 2.6z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "a9",
    d: "m572.9 753.4c2.9 1.2 4.6 4.3 4.5 8.6-0.3 14.5-15.1 28.2-22.4 22.2l0.1-0.1c2.3 0.8 5.1 0.1 7.5-1.2 3.7-1.8 6.1-4.8 8.2-8.1 2.7-4.2 4.7-9 4.7-13.9 0-2.6-0.4-4.7-1.9-6.6q-0.3-0.5-0.7-0.8z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "a9",
    d: "m573.6 754.3c1.5 1.9 1.9 4 1.9 6.6 0 4.9-2 9.7-4.7 13.9-2.1 3.3-4.5 6.3-8.2 8.1-2.4 1.3-5.2 2-7.5 1.2l-0.1 0.1c-0.6-0.6-1.2-1.3-1.7-2.2-0.5-0.8-0.7-1.6-0.9-2.5h0.1c3.1 3 8 0.9 11.3-2 1.3 0.2 3-0.5 4.8-2.3 2.3-2.3 3.5-5.4 3.6-8 0.1-1.3-0.3-2.2-0.8-2.9q0.4-1.7 0.4-3.4c0-3.2-1.2-6.5-4.3-7.5 2.1-0.6 3.9-0.6 5.4 0v0.1q0.4 0.3 0.7 0.8z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "a7",
    d: "m571.4 764.3c0.5 0.7 0.9 1.6 0.8 2.9-0.1 2.6-1.3 5.7-3.6 8-1.8 1.8-3.5 2.5-4.8 2.3q-0.6-0.1-1-0.4c-1.2-0.6-1.8-2.2-1.6-4.4 0.3-2.8 1.7-5.3 3.6-7.2 2.1-2.1 4.2-2.6 5.6-2 0.3 0.2 0.7 0.4 1 0.8z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "m570.4 763.5c-1.2-0.7-2.4-1.4-3.6-2.1-1.4-0.8-3.2-0.1-4.6 0.9-2.4 1.6-4.5 5.3-4.8 8.2-0.1 1.7 0.2 3.7 1.6 4.5q1.9 1.1 3.8 2.1 0.4 0.3 1 0.4c-3.3 2.9-8.2 5-11.3 2h-0.1c-0.3-1.5-0.3-3.2-0.1-4.9 0.8-6.3 3.8-12.1 8.1-16.5 2.5-2.5 4.9-4 7.1-4.7 3.1 1 4.3 4.3 4.3 7.5q0 1.7-0.4 3.4c-0.3-0.4-0.7-0.6-1-0.8z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "m570.4 763.5c-1.4-0.6-3.5-0.1-5.6 2-1.9 1.9-3.3 4.4-3.6 7.2-0.2 2.2 0.4 3.8 1.6 4.4q-1.9-1-3.8-2.1c-1.4-0.8-1.7-2.8-1.6-4.5 0.3-2.9 2.4-6.6 4.8-8.2 1.4-1 3.2-1.7 4.6-0.9 1.2 0.7 2.4 1.4 3.6 2.1z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "m561 721.2l-9.5-1.5v-27.3l10.5 1.7c3.3 0.5 5.3 3.1 5.3 5.1v18.6c0 0.5-0.1 1-0.4 1.4v0.1c-0.7 1.5-2.5 2.4-4.9 2.1z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "m561 736v7c-6.8 4.7-13 13.2-17 20.5l-1.3-0.7-14.8 8.5 10.3-17.7z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "m561 727.9v8.1l-22.8 17.6 13.3-20.2z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "m561 721.2v6.7l-9.5 5.5v-13.7z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "m561 673.3v19.3l-9.5-1.4v-12.4z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "m553.4 661.4l7.6 11.9-9.5 5.5-7.6-11.8z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "m553.3 789.2l1.1 0.5c-3.9-2.2-8.9-4.9-12.8-7.2-1.9-1.1-3.7-3.2-4.4-6.6l1.2-0.7c2.6 1.4 5.1 2.9 7.6 4.3q1.2-0.6 2.4-1.4c0 2.3 0.2 4.3 0.9 6.1 0.8 1.9 2.3 3.8 4 5z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "m551.5 719.7v13.7l-22.8 4.4 3.8-56.8 19-2.2v12.4 1.2z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "m534.6 683l14.6-1.7v50.2l-18 3.5z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "m543.9 667l7.6 11.8-19 2.2 5.7-17.3z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "m551.5 733.4l-13.3 20.2-32.2-1.1 22.7-14.7z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "m548.4 766v3.4l-10 5.8-1.2 0.7-10.3 6v-3.4z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "m548.4 766l-21.5 12.5-25.4-5.8-47.9-27.7-10.2-14.7 11.9-6.8-1.8 8.7 7 10.2 7.5 4.4 30.3 17.4 7.7 4.5 18.9 4.3 3-1.7 14.8-8.5 1.3 0.7z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "m538.4 775.2l10-5.8q-1.4 3.7-2 7.6c-0.2 0.8-0.3 1.7-0.4 2.5-2.5-1.4-5-2.9-7.6-4.3z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "a9",
    d: "m548.4 778.1q-1.2 0.8-2.4 1.4c0.1-0.8 0.2-1.7 0.4-2.5 0.6 0.4 1.3 0.7 2 1.1z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "m538.2 663.7l-5.7 17.3-13.4-7.7 11.4-14.1z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "am",
    d: "m538.2 753.6l-10.3 17.7-3 1.7-18.9-4.3v-16.2zm-19.2 16.1c5.9-0.8 9.2-7.3 4.3-10.7-5.6-3.9-16.6-0.7-14 5.6 1.3 3.1 5.5 5.7 9.7 5.1z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "m532.5 681l-3.8 56.8-13.3-7.7-30.3-17.5-13.2-7.7 0.5-7.8 2.7-39.6 0.6-9.3 13.2 7.6 30.2 17.5z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "m474.3 703.7l0.4-6.4 3-45.4 40.3 23.3 12.1 7-3.4 51.8z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "m530.5 659.2l-11.4 14.1-30.2-17.5 11.4-14z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "m528.7 737.8l-22.7 14.7-7.7-4.5 17.1-17.9z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "m526.9 778.5v3.4l-25.4-5.9v-3.3z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "a6",
    d: "m523.2 759c4.9 3.4 1.7 9.9-4.2 10.7-4.2 0.6-8.4-2-9.7-5.2-2.6-6.3 8.4-9.4 13.9-5.5z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "m515.4 730.1l-17.1 17.9-30.3-17.4 17.1-18z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "m506 752.5v16.2l-7.7-4.5v-16.2z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "m501.5 772.7v3.3l-47.9-27.6v-3.4z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "m500.3 641.8l-11.4 14-13.2-7.6 17-10.8z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "m498.3 748v16.2l-30.3-17.4v-16.2z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "m543.9 601.3l-56.9 32.8 56.9 32.9 56.8-32.9z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "m536.3 604.4l-9.1 5.2-24.2 14-23.6 13.6 7.6-3.1 5.7-3.2 11.5-6.7 30.6-17.6 9.1-5.3z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "m477.3 643.4l2.1-6.2 7.6-3.1 5.7 3.3-17 10.8 1-3z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "m485.1 712.6l-17.1 18-7.5-4.4 11.4-21.3z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "m476.7 645.2l-1 3-0.6 9.3v-11.5c0-1.3 0.2-2.2 0.6-2.3 0.3 0 0.6 0.5 1 1.5z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "m472.4 697.1l-0.5 7.8-11.4 21.3-1.9-18.6z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "m468 730.6v16.2l-7.5-4.4v-16.2z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "am",
    d: "m460.5 726.2v16.2l-7-10.2 1.8-8.7 3.3-15.9zm-0.6 8.1c0.1-2-0.2-10.6-1.1-12.3-1.1-2.3-3.7 6.5-1.9 12.5 0.3 0.8 0.9 2.3 1.8 2.6 1 0.5 1.2-1.6 1.2-2.8z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "a6",
    d: "m458.8 721.9c0.9 1.8 1.2 10.4 1.1 12.4 0 1.2-0.2 3.3-1.2 2.8-0.8-0.3-1.5-1.8-1.8-2.6-1.8-6 0.8-14.8 1.9-12.6z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "m453.6 745v3.4l-10.2-14.7v-3.4z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "m780.3 655.3c7.7-0.8 11.7-5 14.8-10 2.7-4.2 4.7-9 4.7-13.9 0-2.9-0.5-5.2-2.6-7.4 2.9 1.1 4.6 4.2 4.6 8.5-0.5 13.8-14 27-21.5 22.8z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "m776.7 650.1c3.1 2.8 7.7 1 11-1.8 1.4 0.4 3.2-0.2 5.1-2.1 2.3-2.4 3.5-5.4 3.6-8.1 0-1.2-0.3-2.2-0.8-2.9 0.3-1.2 0.4-2.5 0.4-3.8 0-4.4-1.8-6.8-4.3-7.4 2.1-0.7 4-0.7 5.5 0 2.1 2.2 2.6 4.5 2.6 7.4 0 4.9-2 9.7-4.7 13.9-3.1 5-7.1 9.2-14.8 10q-1.5-0.8-2.7-2.8c-0.5-0.8-0.7-1.6-0.9-2.4z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "m781.6 641.4c0.3-2.9 2.4-6.6 4.7-8.2 1.4-0.9 3.3-1.7 4.7-0.9q1.8 1.1 3.5 2.1c-1.4-0.6-3.4-0.1-5.5 2-1.9 1.9-3.2 4.5-3.6 7.3-0.3 2.2 0.4 3.7 1.6 4.4q-1.9-1.1-3.8-2.2c-1.4-0.8-1.8-2.8-1.6-4.5z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "m776.6 645.2c0.7-6.4 3.8-12.2 8.1-16.6 2.5-2.4 4.9-3.9 7-4.6 2.5 0.6 4.3 3 4.3 7.4 0 1.3-0.1 2.6-0.4 3.8q-0.4-0.5-1.1-0.8-1.7-1-3.5-2.1c-1.4-0.8-3.3 0-4.7 0.9-2.3 1.6-4.4 5.3-4.7 8.2-0.2 1.7 0.2 3.7 1.6 4.5q1.9 1.1 3.8 2.2 0.3 0.2 0.7 0.2c-3.3 2.8-7.9 4.6-11 1.8-0.3-1.6-0.3-3.3-0.1-4.9z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "m785.4 643.7c0.4-2.8 1.7-5.4 3.6-7.3 2.1-2.1 4.1-2.6 5.5-2q0.7 0.3 1.1 0.8c0.5 0.7 0.8 1.7 0.8 2.9-0.1 2.7-1.3 5.7-3.6 8.1-1.9 1.9-3.7 2.5-5.1 2.1q-0.4 0-0.7-0.2c-1.2-0.7-1.9-2.2-1.6-4.4z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ax",
    d: "m785.8 660.2c-3.5 1.1-6.3 0.8-8.5-0.6v0.1q-5.7-3.3-11.4-6.6c0.5 0.3 1 0.5 1.5 0.6l2.4 1.4 3-1.9c-0.6-13.2 8.7-27.3 18.3-33.3 0.1 0 0.1-0.1 0.1-0.1 3.7-1.5 7-1.5 9.5 0 2.5 1.5 4.3 4.4 4.6 8.7 0.1 0.6 0.1 1.2 0.1 1.8 0 13.1-10.7 27-19.6 29.9zm-19.9-7.1q0-0.1-0.1-0.1 0.1 0 0.1 0.1zm11.7-0.6q1.2 2 2.7 2.8c7.5 4.2 21-9 21.5-22.8 0-4.3-1.7-7.4-4.6-8.5-1.5-0.7-3.4-0.7-5.5 0-2.1 0.7-4.5 2.2-7 4.6-4.3 4.4-7.4 10.2-8.1 16.6-0.2 1.6-0.2 3.3 0.1 4.9 0.2 0.8 0.4 1.6 0.9 2.4z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "a8",
    d: "m791.2 619.8c4.1-2.5 8.3-3.6 11.7-2.5 2.7 0.9 5.1 3.1 6.3 5.8 1.3 2.6 1.5 5.5 1.3 8.4l-5.1-3h-0.1c-0.3-4.3-2.1-7.2-4.6-8.7-2.5-1.5-5.8-1.5-9.5 0z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "m769.8 655.1c-0.7-16.5 12.5-35.6 25.1-40.6 3.1-1.3 6.7-2 9.8-1 0.4 0.1 0.8 0.3 1.2 0.4 2.6 1.3 4.8 3.6 6.1 6.3 1.4 2.9 1.7 6.3 1.5 9.5q0 0.1 0 0.2l-3 1.6c0.2-2.9 0-5.8-1.3-8.4-1.2-2.7-3.6-4.9-6.3-5.8-3.4-1.1-7.6 0-11.7 2.5 0 0 0 0.1-0.1 0.1-9.6 6-18.9 20.1-18.3 33.3z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "a9",
    d: "m777.6 607.6c3.8-1.9 8.4-3.3 12.3-2.4q1.6 0.2 2.9 1c2.7 1.6 5.4 3.2 8.1 4.7 1.7 1 3.3 2 5 3-0.4-0.1-0.8-0.3-1.2-0.4-3.1-1-6.7-0.3-9.8 1-12.6 5-25.8 24.1-25.1 40.6l-2.4-1.4-11.8-6.8c-0.3-4.7 0.7-9.3 2.3-13.8 1.4-3.8 3.3-7.5 5.4-11 0.5-0.8 1-1.6 1.6-2.4 3.3-4.9 7.2-9.2 12.7-12.1z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "C",
    d: "m661 621.9q2.7-0.1 4 2.7 1.2 2.7 1.2 8.9 0 6.2-1.2 10.4-1.3 4.2-4 7.3-2.8 3-7.6 5.8-5.5 3.2-11.7 6.4v-31.4q6.2-4 11.7-7.2 4.8-2.8 7.6-2.9zm-3.5 26.9q1.5-1.9 2.1-4.6 0.6-2.8 0.6-7.2 0-4.4-0.6-6.5-0.6-2.1-2.1-2.3-1.5-0.2-4.1 1.3l-6 3.6v22.5q3.5-1.9 6-3.4 2.6-1.5 4.1-3.4z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m692.2 629.6l0.3 4.2q-2.8 1.8-6 3.7-3.1 1.9-7.9 4.6-3.1 1.8-4.8 1.2-1.8-0.5-1.9-3.3v-19.6q0.1-2.8 1.9-5.4 1.7-2.6 4.8-4.4 4.8-2.8 7.9-4.5 3.2-1.8 6-3.1l-0.3 4.5-12.3 7.1q-1.2 0.7-1.7 1.6-0.6 0.9-0.6 2.3v5.5l12.9-7.4v4.3l-12.9 7.5v7q0 1.4 0.6 1.7 0.5 0.3 1.7-0.4z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m703.6 620.3q0 1.5 0.6 1.7 0.6 0.2 2.1-0.7l10.9-6.3 0.2 4.3q-4.4 3-12.4 7.6-7.1 4.1-7.1-2.4v-25l5.7-3.3z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m727.4 613.9l-5.7 3.3v-31.4l5.7-3.3z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m749.8 599.4q-0.2 0.8-0.8 1.6-0.6 0.7-1.3 1.2l-5.4 3.1q-0.7 0.4-1.3 0.3-0.5-0.1-0.7-0.8l-8.9-24.6 5.8-3.4 6.4 19.9 0.9 3 1.1-0.7q0.3-1.6 0.9-4l6.3-27.1 5.8-3.4z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m782.6 577.4l0.3 4.1q-2.7 1.8-5.9 3.8-3.2 1.9-7.9 4.6-3.1 1.8-4.9 1.2-1.8-0.5-1.8-3.3v-19.6q0-2.8 1.8-5.4 1.8-2.7 4.9-4.5 4.7-2.7 7.9-4.5 3.2-1.7 5.9-3.1l-0.3 4.5-12.2 7.1q-1.3 0.7-1.8 1.6-0.5 0.9-0.5 2.4v5.5l12.9-7.4v4.3l-12.9 7.4v7q0 1.5 0.5 1.8 0.5 0.3 1.8-0.4z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "C",
    d: "m811.9 565.1l-6 3.5-2.5-8.3q-0.5-1.3-1.3-1.4-0.9-0.2-2.4 0.7l-5.6 3.2v12.6l-5.6 3.2v-31.3q2.5-1.8 4.8-3.2 2.3-1.4 6.6-3.8 4-2.4 6.3-2.9 2.4-0.5 3.5 0.8 1.1 1.4 1.1 4.9 0 3.7-1.4 6.4-1.3 2.7-4.5 4.9v0.3q1.4-0.5 2.6-0.1 1.1 0.5 1.6 2.3zm-9-12.5q1.1-1.1 1.6-2.5 0.5-1.3 0.5-3.3 0-1.9-0.5-2.7-0.5-0.8-1.6-0.5-1.1 0.2-3.2 1.4l-5.6 3.3v9.8l5.6-3.2q2.1-1.2 3.2-2.3z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m829.2 544.5v10.6l-5.7 3.3v-10.7l-10.3-14.7 6-3.5 5.7 8.9q0.4 0.7 0.8 1.7 0.4 1 0.5 1.3l0.4-0.2q0.1-0.4 0.5-1.9 0.3-1.4 0.7-2.6l5.8-15.5 5.9-3.4z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "A",
    d: "m848.7 578.6c0 0-23.4 13.2-22.8 13.1 2.2-0.2 88.7 51 88.7 51 0 0-4.1 8-4.4 8.3-5.9 5.9-11.8 11.9-17.8 17.7-1.5 1.5-3.4 2.4-5.2 3.5-7.1 4.2-71.3 41.2-73.5 42.4-18.7 10.8-10.6 6.3-69.5 40-1.7 1-3.4 2.1-5.2 2.8-0.9 0.5-2.2 0.4-3.3 0.4-4.5-0.1-22.4-0.8-41.5-1.4-3.5-0.2-7-0.3-10.7-0.2 2.5 1 3 3.4 4.3 5.5-18.7 10.8-37.4 21.5-56.3 32.5 1.5 0.3 2.7 0.5 4.1 0.8-0.2 0.6-0.4 1-0.6 1.4-0.7 0-1.3 0-1.9 0-4.7-0.2-9.4-0.5-14.1-0.5-2.5 0-4.9 0.5-7.4 0.8 0 0-26.6 3-28.8 3.3-0.7 0.1-1.3 0.3-1.8 0.7-1.7 0.9-3.4 2-5 3.1-1.3 0.8-2.5 1.3-4 1.4q-4 0.4-8 0.9c-0.7 0-1.3 0.2-1.8 0.5-3.1 1.7-6.2 3.4-9.1 5.3-2 1.3-4.1 1.3-6.1 0.9-5.2-1-17.2-3.9-23.6-5.3-2.1-0.4-3.7-1.6-5.4-2.6-8.4-4.8-25.2-14.6-38.7-22.4-0.5-0.3-1.1-0.7-1.7-1-2.4-1-4.1-2.7-5.5-4.9-2.4-3.7-5-7.2-7.5-10.7-0.1-0.3-0.2-0.5-0.3-0.8 2.5-1.5 7.5-3.4 10.1-4.9 9.9 5.7 17.1 9.8 27.2 15.7 0-2 0.3-1.7 0.3-3.7 8.5 1.9 16.7 3.8 25 5.7 3.7-2.1 7.5-4.3 11.3-6.5q0-0.1-0.1-0.2c-3.5 0.3-13 1.7-13 1.7 0 0-13.6-3.4-18.8-4.5 0-5.5 0-10.9 0-16.2 4.9-4.2 18.2-14.6 22.6-14.6l3.8-56.9q3.4-0.4 6.6-0.8c3.9-0.5 7.7-0.8 11.5-1.4 1.4-0.3 2.8-1.2 4.1-2 20.2-11.6 33.9-19.6 52.4-30.3 0.3-0.1 0.6-0.3 1.1-0.5 0 7.6 0 15 0 22.5 8 4.6 15.9 9.2 23.9 13.9 0-26.5 0-52.7 0-78.9 31.2-18.7 216.4-123.1 216.4-123.1zm-337 173.1q0.1 0.2 0.1 0.4c8.8 0.4 17.6 0.8 26.5 1.1 1.9-2.7 3.7-5.5 5.6-8.4-0.6 0-1-0.1-1.4 0-2.1 0.1-4.2 0.3-6.3 0.5-2 0.2-4.1 0.6-6.1 0.8-1.8 0.2-3.7 0.6-5.6 0.6-1.6-0.1-3.2 0.1-4.7 0.9q-4 2-8.1 4.1zm54.1-56.9c0.2-0.5 0.1-0.8-0.5-1.2-2.3-1.6-4.7-1.2-7.3-0.6 2.7 0.6 5.2 1.2 7.8 1.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport);
export default __webpack_public_path__ + "static/media/transport.72486ebe01065b05541144d0440b086c.svg";
export { ForwardRef as ReactComponent };